import ButtonsDesign from '@/components/designs/ButtonsDesign.vue';
import ComboDesign from '@/components/designs/ComboDesign.vue';
import TablesDesign from '@/components/designs/TablesDesign.vue';
import RolesDesign from '@/components/designs/RolesDesign.vue';
import SpinLoaderDesign from '@/components/designs/SpinLoaderDesign.vue';
import EmbeddableWidgetDesign from '@/components/designs/EmbeddableWidgetDesign.vue';
import PillsDesign from '@/components/designs/PillsDesign.vue';
import BulkSendDesign from '@/components/designs/BulkSendDesign.vue';
import ProgressSteppersDesign from '@/components/designs/ProgressSteppersDesign.vue';
import IconsDesign from '@/components/designs/IconsDesign.vue';
import BrandDesign from '@/components/designs/BrandDesign.vue';
import UpsellsDesign from '@/components/designs/UpsellsDesign.vue';
import EmptyStatesDesign from '@/components/designs/EmptyStatesDesign.vue';

const routes = [
  {
    path: '/designs/buttons',
    component: ButtonsDesign,
  },
  {
    path: '/designs/pills',
    component: PillsDesign,
  },
  {
    path: '/designs/roles',
    component: RolesDesign,
  },
  {
    path: '/designs/embeddable-widget',
    component: EmbeddableWidgetDesign,
  },
  {
      path: '/designs/tables',
      component: TablesDesign,
  },
  {
    path: '/designs/spin-loader',
    component: SpinLoaderDesign,
  },
  {
    path: '/designs/bulk-send',
    component: BulkSendDesign,
  },
  {
    path: '/designs/combo',
    component: ComboDesign,
  },
  {
    path: '/designs/progress-steppers',
    component: ProgressSteppersDesign,
  },
  {
    name: 'Icons',
    path: '/designs/icons',
    component: IconsDesign,
  },
  {
    name: 'Signable Brand Components',
    path: '/designs/brand',
    component: BrandDesign,
  },
  {
    name: 'Product-Led Upsells Components',
    path: '/designs/upsells',
    component: UpsellsDesign,
  },
  {
    name: 'Empty States',
    path: '/designs/empty-states',
    component: EmptyStatesDesign,
  },
];

// Only export if not in production
const shouldExport =
  process.env.VUE_APP_ENV !== 'production' ||
  process.env.VUE_APP_IS_LOCAL === 'true';

export default shouldExport ? routes : [];
